"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpectrumSequentialItemList = exports.SpectrumSequentialItem = exports.HeaderEnvelope = exports.EventEnvelope = exports.Frame = void 0;
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
function createBaseFrame() {
    return { headerEnvelope: undefined, eventEnvelopes: [] };
}
exports.Frame = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.headerEnvelope !== undefined) {
            exports.HeaderEnvelope.encode(message.headerEnvelope, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.eventEnvelopes) {
            exports.EventEnvelope.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFrame();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.headerEnvelope = exports.HeaderEnvelope.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.eventEnvelopes.push(exports.EventEnvelope.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFrame();
        message.headerEnvelope =
            object.headerEnvelope !== undefined && object.headerEnvelope !== null
                ? exports.HeaderEnvelope.fromPartial(object.headerEnvelope)
                : undefined;
        message.eventEnvelopes =
            object.eventEnvelopes?.map((e) => exports.EventEnvelope.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEventEnvelope() {
    return {
        eventBytes: new Uint8Array(),
        clientEpochMs: "0",
        sequenceNumber: "0",
        voltronStitchId: "",
        clientNodepEpochMs: "0",
        networkConnectivityType: 0,
    };
}
exports.EventEnvelope = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.eventBytes.length !== 0) {
            writer.uint32(10).bytes(message.eventBytes);
        }
        if (message.clientEpochMs !== "0") {
            writer.uint32(16).int64(message.clientEpochMs);
        }
        if (message.sequenceNumber !== "0") {
            writer.uint32(24).int64(message.sequenceNumber);
        }
        if (message.voltronStitchId !== "") {
            writer.uint32(34).string(message.voltronStitchId);
        }
        if (message.clientNodepEpochMs !== "0") {
            writer.uint32(40).int64(message.clientNodepEpochMs);
        }
        if (message.networkConnectivityType !== 0) {
            writer.uint32(56).int32(message.networkConnectivityType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventEnvelope();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eventBytes = reader.bytes();
                    break;
                case 2:
                    message.clientEpochMs = longToString(reader.int64());
                    break;
                case 3:
                    message.sequenceNumber = longToString(reader.int64());
                    break;
                case 4:
                    message.voltronStitchId = reader.string();
                    break;
                case 5:
                    message.clientNodepEpochMs = longToString(reader.int64());
                    break;
                case 7:
                    message.networkConnectivityType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseEventEnvelope();
        message.eventBytes = object.eventBytes ?? new Uint8Array();
        message.clientEpochMs = object.clientEpochMs ?? "0";
        message.sequenceNumber = object.sequenceNumber ?? "0";
        message.voltronStitchId = object.voltronStitchId ?? "";
        message.clientNodepEpochMs = object.clientNodepEpochMs ?? "0";
        message.networkConnectivityType = object.networkConnectivityType ?? 0;
        return message;
    },
};
function createBaseHeaderEnvelope() {
    return {
        clientHeaderBytes: new Uint8Array(),
        serverHeaderBytes: new Uint8Array(),
        sessionId: "",
        partitionKey: "",
        kafkaClusterNumber: 0,
        ingestorHeaderBytes: new Uint8Array(),
    };
}
exports.HeaderEnvelope = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientHeaderBytes.length !== 0) {
            writer.uint32(10).bytes(message.clientHeaderBytes);
        }
        if (message.serverHeaderBytes.length !== 0) {
            writer.uint32(18).bytes(message.serverHeaderBytes);
        }
        if (message.sessionId !== "") {
            writer.uint32(26).string(message.sessionId);
        }
        if (message.partitionKey !== "") {
            writer.uint32(34).string(message.partitionKey);
        }
        if (message.kafkaClusterNumber !== 0) {
            writer.uint32(40).int32(message.kafkaClusterNumber);
        }
        if (message.ingestorHeaderBytes.length !== 0) {
            writer.uint32(50).bytes(message.ingestorHeaderBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeaderEnvelope();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientHeaderBytes = reader.bytes();
                    break;
                case 2:
                    message.serverHeaderBytes = reader.bytes();
                    break;
                case 3:
                    message.sessionId = reader.string();
                    break;
                case 4:
                    message.partitionKey = reader.string();
                    break;
                case 5:
                    message.kafkaClusterNumber = reader.int32();
                    break;
                case 6:
                    message.ingestorHeaderBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseHeaderEnvelope();
        message.clientHeaderBytes = object.clientHeaderBytes ?? new Uint8Array();
        message.serverHeaderBytes = object.serverHeaderBytes ?? new Uint8Array();
        message.sessionId = object.sessionId ?? "";
        message.partitionKey = object.partitionKey ?? "";
        message.kafkaClusterNumber = object.kafkaClusterNumber ?? 0;
        message.ingestorHeaderBytes =
            object.ingestorHeaderBytes ?? new Uint8Array();
        return message;
    },
};
function createBaseSpectrumSequentialItem() {
    return { item: undefined };
}
exports.SpectrumSequentialItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item?.$case === "headerEnvelope") {
            exports.HeaderEnvelope.encode(message.item.headerEnvelope, writer.uint32(10).fork()).ldelim();
        }
        if (message.item?.$case === "eventEnvelope") {
            exports.EventEnvelope.encode(message.item.eventEnvelope, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpectrumSequentialItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.item = {
                        $case: "headerEnvelope",
                        headerEnvelope: exports.HeaderEnvelope.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.item = {
                        $case: "eventEnvelope",
                        eventEnvelope: exports.EventEnvelope.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSpectrumSequentialItem();
        if (object.item?.$case === "headerEnvelope" &&
            object.item?.headerEnvelope !== undefined &&
            object.item?.headerEnvelope !== null) {
            message.item = {
                $case: "headerEnvelope",
                headerEnvelope: exports.HeaderEnvelope.fromPartial(object.item.headerEnvelope),
            };
        }
        if (object.item?.$case === "eventEnvelope" &&
            object.item?.eventEnvelope !== undefined &&
            object.item?.eventEnvelope !== null) {
            message.item = {
                $case: "eventEnvelope",
                eventEnvelope: exports.EventEnvelope.fromPartial(object.item.eventEnvelope),
            };
        }
        return message;
    },
};
function createBaseSpectrumSequentialItemList() {
    return { spectrumSequentialItems: [] };
}
exports.SpectrumSequentialItemList = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.spectrumSequentialItems) {
            exports.SpectrumSequentialItem.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpectrumSequentialItemList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.spectrumSequentialItems.push(exports.SpectrumSequentialItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSpectrumSequentialItemList();
        message.spectrumSequentialItems =
            object.spectrumSequentialItems?.map((e) => exports.SpectrumSequentialItem.fromPartial(e)) || [];
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=frame.js.map